var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
var TopTenPatientReport = /** @class */ (function (_super) {
    __extends(TopTenPatientReport, _super);
    function TopTenPatientReport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopTenPatientReport.prototype.getPatientName = function () {
        return this.patient_name;
    };
    TopTenPatientReport.prototype.getTotalPackageReservations = function () {
        return Number(this.package_reservation_count);
    };
    TopTenPatientReport.prototype.getTotalAppointment = function () {
        return Number(this.appointments_count);
    };
    TopTenPatientReport.prototype.getTotalTransactions = function () {
        return this.roundNumber(this.total_transactions);
    };
    return TopTenPatientReport;
}(Model));
export default TopTenPatientReport;
